module.exports = __webpack_public_path__ + "static/media/Camada_6.0c5f5871.svg";